import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://tqcpqryiezrfqhzaedhv.supabase.co'
const supabaseKey = 'sb_publishable_trUGNIByknIesGjxeWhxpQ_UxNt0GrK'

export const supabase = createClient(supabaseUrl, supabaseKey)

// Client « visiteur » : n'attache JAMAIS la session du navigateur.
// Une cliente qui réserve doit TOUJOURS écrire en ANONYME. Si une session
// pro/collab traîne dans le même navigateur (un pro qui réserve chez un
// confrère, un téléphone ayant servi à se connecter à l'espace pro…), le
// client principal l'envoie avec la requête → la RLS applique la règle des
// PROS (« on n'écrit que chez soi ») et refuse la réservation de la cliente
// (SAV N'Beauté 2026-08-18 : « un souci technique a empêché l'enregistrement »,
// 403 en boucle depuis Chrome iPhone). storageKey distinct : ne partage ni
// n'écrase la session stockée par le client principal.
export const supabasePublic = createClient(supabaseUrl, supabaseKey, {
  auth: { persistSession: false, autoRefreshToken: false, detectSessionInUrl: false, storageKey: 'sb-avelis-public' },
})
